import appConfig from '../../config/appConfig';
import ExponentialBackOff from '../../utils/exponentialBackOff';
import cryptoService from '../cryptoService';
import * as gigyaService from '../gigya/gigyaService';
import log from '../logger/log';
import iccMarketService from './iccMarketService';

const trackStartConnectEvent = (codentify) => {
    const productId = cryptoService.hashMD5(codentify);
    const marketIso = appConfig.getScpCloudTopicMarket();

    const exponentialBackOff = new ExponentialBackOff({
        max: 3,
        delay: 2000,
        toTry: () => {
            const gigyaToken = gigyaService.getGigyaToken();

            return iccMarketService.postStartConnectEvent({productId, marketIso, gigyaToken});
        },
        fail: (e) => {
            log.info(`useStartConnectGamEvent: error ${JSON.stringify(e)}`);
        },
    });

    exponentialBackOff.run();
};

export default {
    trackStartConnectEvent,
};
